import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Button } from "../utils/button/button";
import { Icon } from "../utils/icon/icon";

@Component({
  selector: "app-card",
  imports: [Button, Icon],
  templateUrl: "./card.html",
  styleUrl: "./card.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class Card {
  title = input.required<string>();
  text = input.required<string>();
  extraClass = input<string>();
  iconName = input<string>("thunder");
  buttonText = input.required<string>();
  buttonVariant = input<string>("primary");

  buttonClick = output();
}
